import { RefObject, useEffect, useState } from 'react';

export const useCollisionDetection = (
  containerRef: RefObject<HTMLElement | null>,
  elementOneRef: RefObject<HTMLElement>,
  elementTwoRef: RefObject<HTMLElement>,
) => {
  const [isCollision, setIsCollision] = useState(false);
  const [isPast, setIsPast] = useState(false);

  useEffect(() => {
    const checkCollision = () => {
      if (!elementOneRef.current || !elementTwoRef.current) {
        return;
      }

      const elementOneRect = elementOneRef.current.getBoundingClientRect();
      const elementTwoRect = elementTwoRef.current.getBoundingClientRect();
      const isOverlapping = !(
        elementOneRect.bottom < elementTwoRect.top ||
        elementOneRect.top > elementTwoRect.bottom
      );

      setIsCollision(isOverlapping);
    };

    const checkIsPast = () => {
      if (!elementOneRef.current || !elementTwoRef.current) {
        return;
      }

      const elementOneRect = elementOneRef.current.getBoundingClientRect();
      const elementTwoRect = elementTwoRef.current.getBoundingClientRect();
      const isFirstPastSecond = elementOneRect.top >= elementTwoRect.top;

      setIsPast(isFirstPastSecond);
    };

    const handleScroll = () => {
      checkCollision();
      checkIsPast();
    };

    const container = containerRef.current?.parentElement;

    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [elementOneRef, elementTwoRef, containerRef]);

  return {
    isCollision,
    isPast,
  };
};
